import {
  TalkhattabatConversationType,
  E_KHATTABAT_APPLICATION_STATUS
} from "../../../../../../Types";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import getKhattabat101CStore from "../../../../../../stores/khattabat-stores/101c-stores/index";
import getKhattabatSharedMessagingStore from "../../../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import SendMessage from "./SendMessage";
import UsersMessages from "./UsersMessages";
import { isPositiveNumber } from "et3-type-guards";

const Messages = withLiteObserverAndTheme<{
  conversationID: string;
  userID: number;
}>((props) => {
  const { theme, conversationID, userID } = props;
  const { messages, conversationType } =
    getKhattabatSharedMessagingStore(conversationID);
  const { colors } = theme;
  const applicationStatus =
    getKhattabat101CStore(userID).applicationStatus.get();
  const borderColor = isPositiveNumber(
    ["101C_COMMENTS", "101M_COMMENTS"].indexOf(conversationType.get()),
    true
  )
    ? `5px solid ${colors.all.red}`
    : `1px solid ${colors.all.black}`;
  const ONE_O_ONE_CONVERSATION_TYPES: TalkhattabatConversationType[] = [
    "101C",
    "101C_COMMENTS"
  ];

  const isOneOOneConversationType = ONE_O_ONE_CONVERSATION_TYPES.includes(
    conversationType.get()
  );

  const shouldHideSendingMessages =
    applicationStatus === E_KHATTABAT_APPLICATION_STATUS.NONE &&
    isOneOOneConversationType;

  return (
    <ET3Div
      width={1188}
      height={428}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        border: borderColor,
        borderRadius: 20,
        overflow: "hidden"
      }}
      color={""}
      justifyContent={"flex-end"}
      withShadow={false}
      isExtendable={false}
      isScrollable={false}
      onClick={() => {}}
    >
      <UsersMessages
        messages={messages.get()}
        conversationID={conversationID}
        conversationType={conversationType.get()}
      />
      <Et3Margin top={5} bottom={5} left={0} right={0} />
      {shouldHideSendingMessages ? null : (
        <SendMessage conversationID={conversationID} />
      )}
    </ET3Div>
  );
});

export default Messages;
